export default __webpack_public_path__ + "e3ea2cd760114114a52cd0ffcbe3dd65.svg";